import chroma from 'chroma-js';

export function handleUpdateTheme(orgTheme) {
  const theme = orgTheme;

  const primaryHex = theme['primaryColor'];
  const secondaryHex = theme['secondaryColor'];

  const rgbPrimary = chroma(primaryHex).rgb().join(' ');
  const rgbSecondary = chroma(secondaryHex).rgb().join(' ');

  document.documentElement.style.setProperty('--color-primary', rgbPrimary);
  document.documentElement.style.setProperty('--color-secondary', rgbSecondary);
}
